import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <IndexSection />
        <FAQSection />
        <UpdatesSection />
        <CommentsSection />
        <CardsSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}